import React, { useState } from 'react';
import { ReEngageEmployeeStatusCarLoan } from '../../../../Constants/Constants';
const EmploymentSts = ({ onNext, answers, stepKey, onGoTo }) => {
  const [error, setError] = useState('');
  const [selectedOption, setSelectedOption] = useState(answers[stepKey] || '');

  const isOtherSelected = selectedOption == 463 || (typeof selectedOption === 'string' && selectedOption.startsWith('463:'));
  const otherValue = isOtherSelected && typeof selectedOption === 'string' ? selectedOption.substring(4) : '';

  const handleChange = (value, isOtherInput = false) => {
    setError(''); // Clear error on any change
    if (isOtherInput) {
      setSelectedOption(`463:${value}`);
    } else {
      setSelectedOption(value);
    }
  };

  const handleContinue = () => {
    console.log('Selected Employment Status:', selectedOption);
    if (!selectedOption) {
      setError('Please select an option.');
      return;
    }
    if (isOtherSelected && otherValue.trim() === '') {
      setError('Please specify your employment status.');
      return;
    }
    onNext(selectedOption);
  };

  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">What was your employment status when you took out the car loan?</h2></div>
      <div className="qs-card__body">
        <ul className="qs-list">
          {Object.entries(ReEngageEmployeeStatusCarLoan).map(([key, value]) => {
            if (key == 463) {
              return (
                <li key={key} className="qs-list__item">
                  <div className="qs-other">
                    <button className={`qs-check ${isOtherSelected ? 'is-on' : ''}`} onClick={() => handleChange(463)}>{value}</button>
                    {isOtherSelected && (
                      <input
                        type="text"
                        className={`qs-check ${isOtherSelected ? 'is-show' : ''}`}
                        placeholder="Enter Here"
                        value={otherValue}
                        onChange={(e) => handleChange(e.target.value, true)}
                      />
                    )}
                  </div>
                </li>
              );
            }
            return (
              <li key={key} className="qs-list__item">
                <button className={`qs-check ${selectedOption === key ? 'is-on' : ''}`} onClick={() => handleChange(key)}>{value}</button>
              </li>
            );
          })}
        </ul>
        <div className="qs-actions">
          <button type="button" className="qs-btn qs-btn--primary" onClick={handleContinue}data-quest-id={144}>Continue <span className="qs-arrow">→</span></button>
        </div>
        {error && <p className="qs-error-message" style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
      </div>
    </>
  );
};

export default EmploymentSts;
